import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { UserPouchContent } from '@libs/shared/interfaces/couch/models/user';

@Injectable({
  providedIn: 'root',
})
@StoreConfig({
  name: 'user',
})
export class UserStore extends Store<UserPouchContent> {
  constructor() {
    super({});
  }
}
